import React from 'react';
import './CompanyAvatar.css';
import cicleFog from "../../assets/Frame 427320212.png";

const CompanyAvatar = ({
  avatar,
  width = '80px',
  height = '80px',
}) => {
  return (
    <div
      className="company-avatar-wrapper"
      style={{ width, height }}
    >
      <div className="avatar-image-wrapper">
        <img
          src={avatar || cicleFog}
          sx={{
            width: '100%',
            height: '100%'
          }}
          alt="Avatar"
          className="avatar-image"
        />
      </div>
    </div>
  );
};

export default CompanyAvatar;
